module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.projectStatusList,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          staticClass: "px-1",
          attrs: {
            "width": "5%"
          }
        }, [_c('v-btn', {
          staticClass: "sortHandle",
          staticStyle: {
            "cursor": "move"
          },
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("drag_handle")])], 1)], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "40%"
          }
        }, [_vm._v(_vm._s(props.item.text))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "35%"
          }
        }, [_vm._v(_vm._s(props.item.obj.tender_winning))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PROJECTS') !== -1) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditStatus(props.item.obj.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PROJECTS') !== -1) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeleteStatus(props.item.obj.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete_forever")])])]) : _vm._e()])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('modal')], 1)
},staticRenderFns: []}